export default __webpack_public_path__ + "static/media/roundBg.452d74b8.png";